"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopIconButtons = void 0;
var _react = _interopRequireDefault(require("react"));
var _internal = require("../../hooks/internal");
var _Remove = require("./Remove");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/*
 * This component is responsible for rendering the top icon buttons in the ProductBox component.
 * Should not be used together with PointsOrDealLabel and BottomIconButtons
 */
const TopIconButtons = () => {
  const {
    buttons,
    code,
    onRemoveButtonClick
  } = (0, _internal.useProduct)();
  const {
    disabled,
    trigger,
    visible
  } = buttons?.remove ?? {};
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconWrapper, {
    position: "top",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Remove.Remove, {
      code: code,
      disabled: disabled,
      onRemoveButtonClick: trigger ? onRemoveButtonClick : undefined
    })
  });
};
exports.TopIconButtons = TopIconButtons;
//# sourceMappingURL=TopIconButtons.js.map